import { Helmet } from './Helmet';

export const GlobalMetadata = () => {
  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'EducationalOrganization',
    name: 'Upnov IA',
    alternateName: 'Upnov',
    url: 'https://www.upnov.com',
    email: 'info@upnov.com',
    foundingDate: '2019',
    description: 'Upnov helps businesses adopt AI through tailored training, consulting, and integration of AI solutions and projects.',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Coeur Défense',
      addressLocality: 'Courbevoie',
      postalCode: '92400',
      addressCountry: 'FR',
    },
    areaServed: { '@type': 'Country', name: 'France' },
    founder: {
      '@type': 'Person',
      name: 'Cyril Cohen Solal',
      jobTitle: 'Fondateur et formateur',
      sameAs: ['https://www.linkedin.com/in/cyrilcs/'],
    },
    sameAs: [
      'https://www.linkedin.com/company/UPNOV',
      'https://www.crunchbase.com/organization/upnov-ia',
    ],
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
    </Helmet>
  );
};
